import { Box, Flex } from "@radix-ui/themes";
import { useRouter } from "next/router";
import { BusinessCard } from "@/components/businessCard/BusinessCard";
import Main from "@/components/layout/main/Main";
import { BusinessCardHeader } from "@/layouts/BusinessCardHeader";

export default function BusinessCardLayout({
  children,
}: {
  children: React.ReactNode;
}) {
  const router = useRouter();
  const flipped = router.pathname == "/portfolio";

  return (
    <>
      <BusinessCardHeader flipped={flipped} />
      <Main>
        <Flex
          justify={"center"}
          align={"center"}
          className={"w-full h-full bg-[var(--sand-2)]"}
        >
          <Box
            className={"transition-all"}
            style={{
              width: "100%",
              maxWidth: flipped ? "100%" : "512px",
              height: "100%",
              maxHeight: flipped ? "100%" : "288px",
              padding: flipped ? 0 : "9px 16px",
              transitionDuration: "0.8s",
            }}
          >
            <BusinessCard flipped={flipped} />
          </Box>
        </Flex>
      </Main>
    </>
  );
}
